import AppLogo from "@/components/AppLogo";
import { useNavigate } from "@tanstack/react-router";
import { Button } from "../../components/ui/button/button";
import { capturePromoFromUrl } from "@/utils/promo-code";

const WelcomePage = () => {
	const navigate = useNavigate();
	const promoCode = capturePromoFromUrl();

	return (
		<div className="flex flex-col items-center justify-between w-full mx-auto h-[100dvh] max-h-[100dvh] p-6 bg-primary-600">
			<div
				className="animate-fadeIn opacity-0"
				style={{ animationDelay: "0.2s", animationFillMode: "forwards" }}
			>
				<AppLogo theme="light" />
			</div>

			<div className="space-y-4 text-center text-white  max-w-screen-sm">
				<div
					className="animate-fadeIn opacity-0"
					style={{ animationDelay: "0.4s", animationFillMode: "forwards" }}
				>
					<h1 className="text-4xl font-bold text-white">Total Freedom.</h1>
					<h2 className="text-4xl font-bold text-white">Total Control.</h2>
				</div>
				<div
					className="animate-fadeIn opacity-0"
					style={{ animationDelay: "0.6s", animationFillMode: "forwards" }}
				>
					<p>Access and move your available credit with ease -</p>
					<p>all in one secure platform.</p>
				</div>
			</div>

			{/* <div className="bg-fourthGreen rounded-full w-[250px] h-[250px] flex justify-center items-center">
        <p className="text-2xl font-bold text-primary">Image</p>
      </div> */}

			<div className="flex flex-col w-full gap-1  max-w-screen-sm">
				<div
					className="animate-fadeIn opacity-0"
					style={{ animationDelay: "0.8s", animationFillMode: "forwards" }}
				>
					<Button
						data-testid="get-started-button"
						className="w-full"
						variant="secondary"
						onClick={() =>
							navigate({
								to: "/welcome-message",
								search: {
									promo: promoCode ? promoCode : undefined,
								},
							})
						}
					>
						Get Started
					</Button>
				</div>
				<div
					className="animate-fadeIn opacity-0 justify-center flex"
					style={{ animationDelay: "1.0s", animationFillMode: "forwards" }}
				>
					<Button
						data-testid="nav-to-sign-in"
						className="text-white w-full text-center"
						onClick={() => navigate({ to: "/face-id" })}
						variant="unstyled"
					>
						Sign In
					</Button>
				</div>
			</div>
		</div>
	);
};

export default WelcomePage;
